// extracted by mini-css-extract-plugin
export default {"CommentsButton":"im_a bii_wx bii_jb bii_xl bii_i bii_j bii_q bii_vt bii_et bii_so bii_sp bii_eg","CommentsButton__icon":"im_b bii_rz"};